import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Truck, Mail, Phone, UserPlus } from 'lucide-react';
import { useFournisseurs } from '@/hooks/useAchats';
import { NouveauFournisseurDialog } from './NouveauFournisseurDialog';

/**
 * SIMG-ACHATS-LEADBETON-2026-002 — Répertoire fournisseurs (lecture + création rapide).
 */
export const FournisseursPage = () => {
  const { data = [], isLoading } = useFournisseurs();
  const [showNew, setShowNew] = useState(false);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, marginBottom: 6 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800 }}>Fournisseurs</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--tx-3, #6B7280)', fontSize: 13 }}>
            Répertoire des fournisseurs actifs — édition avancée sur le back-office
          </p>
        </div>
        <button
          onClick={() => setShowNew(true)}
          style={{
            padding: '10px 14px', borderRadius: 10, border: 'none',
            background: '#0F766E', color: '#fff', cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 700,
            boxShadow: '0 4px 12px -4px rgba(15,118,110,0.4)',
            whiteSpace: 'nowrap',
          }}
        >
          <UserPlus size={14} /> Nouveau
        </button>
      </div>
      <div style={{ height: 10 }} />

      {isLoading && <div style={{ padding: 24, textAlign: 'center', color: 'var(--tx-3)' }}>Chargement…</div>}

      {!isLoading && data.length === 0 && (
        <div style={{ background: '#fff', border: '1px solid var(--bd-1)', borderRadius: 12, padding: 32, textAlign: 'center' }}>
          <Truck size={40} style={{ color: 'var(--tx-3)', marginBottom: 8 }} />
          <p style={{ color: 'var(--tx-3)', margin: 0 }}>Aucun fournisseur actif dans la filiale.</p>
        </div>
      )}

      {showNew && (
        <NouveauFournisseurDialog
          onClose={() => setShowNew(false)}
          onCreated={() => setShowNew(false)}
        />
      )}

      <div style={{ display: 'grid', gap: 10 }}>
        {data.map((f) => (
          <div key={f.id} style={{
            background: '#fff', border: '1px solid var(--bd-1)', borderRadius: 12, padding: 14,
          }}>
            <div style={{ fontWeight: 700, fontSize: 14, display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              <span>{f.raisonSociale}</span>
              {(f as { contactId?: string | null }).contactId && (
                <Link to={`/finance/releves/${(f as { contactId?: string | null }).contactId}`} style={{ fontSize: 12, fontWeight: 600, color: 'var(--p)' }}>Relevé</Link>
              )}
            </div>
            <div style={{ fontSize: 12, color: 'var(--tx-3)', marginBottom: 8 }}>
              {f.code} · {f.categorie} · règlement {f.delaiPaiementJours}j
            </div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', fontSize: 13 }}>
              {f.tel && (
                <a href={`tel:${f.tel}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: '#0F766E', textDecoration: 'none' }}>
                  <Phone size={13} /> {f.tel}
                </a>
              )}
              {f.email && (
                <a href={`mailto:${f.email}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: '#0F766E', textDecoration: 'none' }}>
                  <Mail size={13} /> {f.email}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
